import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  toastsVisible: false,
  list: [],
};

export const toastsSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    toggleToasts: state => {
      state.toastsVisible = !state.toastsVisible;
    },
    addToast: state => {
      state.list.push(new Date().getTime());
    },
    removeToast: (state, {payload}) => {
      state.list = state.list.filter(toast => toast !== payload);
    },
  },
});

export const { toggleToasts, addToast, removeToast } = toastsSlice.actions;

export const toastsReducer = toastsSlice.reducer;
